import React, { FunctionComponent, useState, useEffect } from "react";
import { Close, HelpDrawer, HelpDrawerToggle } from "@cmsgov/ds-medicare-gov";
import { sendTealiumEvent } from "../helpers";

interface HelpDrawerWrapperProps {
  inlineToggle?: boolean;
  toggleText: string;
  drawerTitle: string;
  tealiumProps?: {
    callingLabel: string;
    label: string;
  };
}

const HelpDrawerWrapper: FunctionComponent<HelpDrawerWrapperProps> = ({
  inlineToggle = false,
  toggleText,
  drawerTitle,
  tealiumProps,
  children,
}) => {
  const [open, setOpen] = useState(false);

  const openDrawer = (): void => {
    if (tealiumProps) {
      sendTealiumEvent(tealiumProps.callingLabel, tealiumProps.label);
    }
    setOpen(true);
  };

  const closeDrawer = (): void => {
    if (tealiumProps) {
      sendTealiumEvent(
        `${tealiumProps.callingLabel} - ${tealiumProps.label}`,
        "Close"
      );
    }
    setOpen(false);
  };

  const clickHandler = (e: MouseEvent): void => {
    const target = e.target as HTMLElement;
    if (
      target.matches(".close-drawer-on-click") ||
      (!target.closest(".mct-c-help-drawer") &&
        !target.matches(".help-drawer-toggle"))
    ) {
      closeDrawer();
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener("click", clickHandler);
    } else {
      document.removeEventListener("click", clickHandler);
    }
  }, [open]);

  return (
    <>
      <HelpDrawerToggle
        helpDrawerOpen={open}
        showDrawer={openDrawer}
        className="help-drawer-toggle"
        inline={inlineToggle}
      >
        {toggleText}
      </HelpDrawerToggle>
      {open && (
        <div className="mct-c-help-drawer ds-u-text-align--left">
          <HelpDrawer
            heading={drawerTitle}
            onCloseClick={closeDrawer}
            closeButtonText={<Close />}
          >
            {children}
          </HelpDrawer>
        </div>
      )}
    </>
  );
};

export default HelpDrawerWrapper;
